module.exports = __webpack_public_path__ + "img/logo-white.1b20e3dc.png";